import React, {useState, useEffect} from "react";
import {Link,useParams} from 'react-router-dom';
import moment from 'moment';
import { postData,getData } from '../../config/api-connect';
import {  Table, Select, DatePicker, Spin, Input, Breadcrumb, Progress, 
  Empty, Typography, Skeleton,Menu, Col, Row, Statistic ,Card,Button } from 'antd';
import { ArrowRightOutlined, HomeOutlined, UserOutlined,FilterFilled,SearchOutlined } from '@ant-design/icons';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as Styled from './style.js';
import Spinner from '../../components/spinner'
import {getSearchFilter,getDropdownFilter} from '../../utils/filterHelper.jsx'
import {toProperCase} from '../../utils/stringUtil.js'

const { Option } = Select;

const RenewalDrilldown = () => {
	var today = new Date();
  var {monthYear} = useParams()
  var splitMonthYear = monthYear.split('-')
  var local_month = splitMonthYear[0] || '';
  var local_year = splitMonthYear[1] || '';

  var local_city = JSON.parse(localStorage.getItem('cityId'))
  let { type} = useParams();
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  var local_game_type = JSON.parse(localStorage.getItem('gameType'))
  if(!local_game_type){
    local_game_type = 8
  }

  const [loading, setLoading] = useState(true)
  const [selectedMonth, setSelectedMonth] = useState(local_month)
  const [selectedYear, setSelectedYear] = useState(local_year)
  const [cityId, setCityId] = useState(local_city)
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [venuelist, setVenuelist] = useState([])
  const [renewalData,setRenewalData] = useState([])
  const [gameType, setGameType] = useState(local_game_type)

  useEffect(() => {
    if(cityId !== ''){
      setLoading(true)
      getRenewalDataByType()
    }
  }, [selectedMonth,selectedYear]); 

  const getRenewalDataByType = () => {
  	setLoading(true)
    getData(`/business/get_renewal_data_by_type/?month=${selectedMonth}&year=${selectedYear}&venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=${gameType}&type=${type}`)
    .then(response =>{
       setRenewalData(response.results);
    })
    .catch(error => {
      console.log(error.message);
    })
    .finally(()=>{
      setLoading(false)
    })
  }

  // const onChangeYear = (date, dateString) => {
  //   setSelectedYear(dateString);
  // };  

  const renderHeader = (title) => {
    return(
      <div style={{ textAlign: 'center', fontWeight: 'bold',textWrap:'nowrap' }}>{title}</div>
    )
  }  

  const getDateSorter = (dataIndex) => ({
    sorter: (a, b) => moment(a[dataIndex]).valueOf() - moment(b[dataIndex]).valueOf(),
  });

  const sampleData = renewalData[0] || {};

	const columns = Object.keys(sampleData).map((key) => ({
	  title: renderHeader(toProperCase(key)),
	  dataIndex: key,
	  align: 'center',
    ...((key === 'Customer' || key === 'Mobile') ? getSearchFilter(key, key) : {}),
    ...((key === 'Venue' || key === 'Renewed') ? getDropdownFilter(key,renewalData) : {}),
    ...((key === 'StartDate' || key === 'EndDate') ? getDateSorter(key) : {}),
	}));

  const combinedMonthYear = () => {
    const dateString = `${selectedYear}-${selectedMonth}`
    return moment(dateString, 'YYYY-MM').format('MMMM YYYY')
  } 

	return(
		<Spin spinning={loading} indicator={<Spinner />}>
			<Styled.MainContainer>
				<Styled.TopDiv>    
          <Breadcrumb style={{padding:'10px'}} >
            <Breadcrumb.Item>
              <Link to="/">
                <HomeOutlined />
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              <Link to="/renewal-analysis">
                <UserOutlined />
                <span style={{paddingLeft:'5px'}}>Renewals</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
            	<span>{toProperCase(type)} Customers</span>
            </Breadcrumb.Item>

          </Breadcrumb>

          {/*<div style={{display: 'flex'}}>
            <Styled.Selector>
              <Select
                  className = 'mainSelector'
                  style={{width: 150}}
                  onChange={setSelectedMonth}
                  value = {selectedMonth}
                  bordered={false}
                >
                  <Option value="12"> December </Option>
                  <Option value="11"> November </Option>
                  <Option value="10"> October </Option>
                  <Option value="09"> September </Option>
                  <Option value="08"> August </Option>
                  <Option value="07"> July </Option>
                  <Option value="06"> June </Option>
                  <Option value="05"> May </Option>
                  <Option value="04"> April </Option>
                  <Option value="03"> March </Option>
                  <Option value="02"> February </Option>
                  <Option value="01"> January </Option>
                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <div className = 'mainSelector'>
                <DatePicker defaultValue={moment(selectedYear, 'YYYY')}  onChange = {onChangeYear}  bordered={false}  picker="year" />
              </div> 
            </Styled.Selector>
          </div>*/}
        </Styled.TopDiv>

        <Styled.NewHeader>  
          <span></span> 
          <span> {toProperCase(type)} Customers {'- ' + combinedMonthYear()}</span>
          {
             <>
              <ReactHTMLTableToExcel
                className="btn btn-sm downloadBtn"
                table="table-for-download"
                filename={`${toProperCase(type)} Customers `  + moment(selectedMonth, 'MM').format('MMMM') + ' ' + selectedYear}
                sheet={`${toProperCase(type)} Customers`}
                buttonText="Download"/>
             </>
          }
        </Styled.NewHeader>
        <div className="recordCount">{renewalData?.length || 0} records</div>
        <div>
        	<Table
            className="drill-down-table table_container"
            rowKey="id"
            columns={columns}
            dataSource={renewalData}
            pagination={{ pageSize: 50, showSizeChanger: false}}
          />
        </div>
			</Styled.MainContainer>
      <table style={{display: 'none'}} id="table-for-download">
        <thead>
          <tr>
            {Object.keys(sampleData).map((head, index) => (
              <th key={index}>{toProperCase(head)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {renewalData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Object.keys(sampleData).map((key, colIndex) => {
                const value = row[key];
                return (
                  <td key={colIndex}>
                    {value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
		</Spin>
	)
}

export default RenewalDrilldown;	